<template>
  <v-dialog v-model="isOpen" max-width="800px" persistent>
    <v-card class="pa-4 rounded-xl">
      <v-card-title class="headline text-orange-darken-2 pb-2">
        <div class="d-flex align-center">
          <v-icon left class="mr-2" color="#1D1B59">fas fa-pen</v-icon>
          {{ $t("views.trips.create_trip.edit_product") }}
        </div>
        <v-btn icon @click="$emit('close')" class="ml-auto">
          <v-icon color="#1D1B59">fas fa-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mb-4" />
      <v-card-text>
       <v-row dense>
          <v-col cols="12" md="6">
            <v-combobox v-model="localProduct.unit" :items="UnitDescriptions"
              :label="$t('views.trips.create_trip.unit')" outlined dense clearable
              :search-input.sync="searchUnit" @change="handleUnitSelected" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="localProduct.barcode" :label="$t('views.trips.create_trip.barcode')" outlined dense />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model.number="localProduct.amount_order"
              :label="$t('views.trips.create_trip.amount_order')" type="number" outlined dense />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model.number="localProduct.amount_deliver"
              :label="$t('views.trips.create_trip.amount_deliver')" type="number" outlined dense />
          </v-col>
          <v-col cols="12" md="6">
            <v-combobox v-model="localProduct.description_product" :items="ProductsList"
              :label="$t('views.trips.create_trip.description_product')" outlined dense clearable
              :search-input.sync="searchDescription" @change="handleProductCodeSelected" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="localProduct.code_product" :label="$t('views.trips.create_trip.code_product')"
              outlined dense :readonly="productExists" />
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="localProduct.routing_variable" :items="LoadTypeDescriptions"
              :label="$t('views.trips.create_trip.routing_variable')" outlined dense clearable
              :search-input.sync="searchTypeLoad" @change="handleLoadTypeSelected" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text color="grey darken-1" class="py-5" @click="$emit('close')">
          {{ $t("views.trips.create_trip.cancel") }}
        </v-btn>
        <v-btn color="orange darken-2" class="py-5" dark @click="save">
          {{ $t("views.trips.create_trip.save_product") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditProductModal",
  props: {
    isOpen: Boolean,
    initialProduct: Object,
    idCompanyParent: {
      type: Number,
      required: true
    }
  },
  emits: ["save", "close"],
  data() {
    return {
      localProduct: { ...this.initialProduct },
      products: [],
      units: [],
      loadTypes: [],
      searchUnit: "",
      searchCode: "",
      searchTypeLoad: "",
      searchDescription: "",
      productExists: true,
    };
  },
  async mounted() {
    try {
      await Promise.all([
        this.loadProducts(),
        this.loadUnits(),
        this.loadLoadTypes()
      ]);
    } catch (err) {
      console.error("Error loading data in edit modal:", err);
    }
  },
  computed: {
    ProductsList() {
      return this.products.map(p => p.description);
    },
    UnitDescriptions() {
      return this.units.map(u => u.description);
    },
    LoadTypeDescriptions() {
      return this.loadTypes.map(t => t.description);
    }
  },
  methods: {
    async loadProducts() {
      try {
        const res = await this.axios.get(`/Product/CodeProduct/${this.idCompanyParent}`);
        this.products = res.data || [];
      } catch (err) {
        console.error("Error loading products:", err);
      }
    },
    async loadUnits() {
      try {
        const res = await this.axios.get(`/Product/TypeCargo/${this.idCompanyParent}`);
        this.units = res.data || [];
      } catch (err) {
        console.error("Error loading units:", err);
      }
    },
    async loadLoadTypes() {
      try {
        const res = await this.axios.get(`/Product/unitOfMeasurement`);
        this.loadTypes = res.data || [];
      } catch (err) {
        console.error("Error loading load types:", err);
      }
    },
    handleUnitSelected(description) {
      const selected = this.units.find(u => u.description === description);
      if (selected) {
        this.localProduct.unit = selected.description;
        this.localProduct.unit_code = selected?.description || "";
        this.UnitExists = true;
      } else {
        this.localProduct.unit = description;
        this.UnitExists = false;
      }
    },

    handleLoadTypeSelected(description) {
      const selected = this.loadTypes.find(l => l.description === description);
      this.localProduct.routing_variable = selected?.description || "";
      this.LoadTypeExists = !!selected;
    },

    handleProductCodeSelected(description) {
      const selected = this.products.find(p => p.description === description);
      this.localProduct.code_product = selected?.code || "";
      this.productExists = !!selected;
    },
    save() {
      console.log("Saving product:", this.localProduct);
      this.$emit("save", { ...this.localProduct });
      this.$emit("close");
    }
  },
  watch: {
    initialProduct(newVal) {
      this.localProduct = { ...newVal };
    }
  }
};
</script>